import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--c4p-ink)] py-14 text-[var(--c4p-ivory)]"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-5">
          <div className="font-display text-[24px] text-white">
            Cash<span className="text-[var(--c4p-orange)]">4</span>Properties
          </div>
          <p className="mt-5 max-w-sm font-sans-ui text-[14px] leading-relaxed text-white/70">
            Local cash home buyers serving Eastern North Carolina with fair,
            fast, no-hassle offers.
          </p>
        </div>

        <div className="lg:col-span-3">
          <div className="eyebrow !text-[var(--c4p-orange)]">Contact</div>
          <ul className="mt-4 space-y-3 font-sans-ui text-[14px] text-[var(--c4p-ivory)]/90">
            <li className="flex items-center gap-3">
              <Phone size={14} className="text-[var(--c4p-orange)]" />
              <a href="tel:+19102125006" data-testid="footer-phone">
                (910) 212-5006
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={14} className="text-[var(--c4p-orange)]" />
              <a
                href="mailto:triston@cash-4-properties.com"
                data-testid="footer-email"
                className="break-all"
              >
                triston@cash-4-properties.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={14} className="text-[var(--c4p-orange)]" />
              Eastern North Carolina
            </li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="eyebrow !text-[var(--c4p-orange)]">Service Area</div>
          <p className="mt-4 font-sans-ui text-[14px] leading-relaxed text-[var(--c4p-ivory)]/80">
            Greenville · Kinston · New Bern · Goldsboro · Wilson · Rocky Mount ·
            Jacksonville · Washington · Ayden · Farmville · and surrounding
            Eastern NC communities.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-12 flex max-w-7xl flex-col items-start justify-between gap-3 border-t border-white/10 px-6 pt-6 font-sans-ui text-[12px] text-[var(--c4p-ivory)]/60 lg:flex-row lg:items-center lg:px-10">
        <div>
          © {new Date().getFullYear()} Cash 4 Properties. All rights reserved.
        </div>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-1">
          <a
            href="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-[var(--c4p-orange)]"
          >
            Privacy Policy
          </a>
          <a
            href="/terms"
            data-testid="footer-terms-link"
            className="hover:text-[var(--c4p-orange)]"
          >
            Terms of Service
          </a>
          <span className="opacity-70">
            Not a solicitation to sellers currently listed with a broker.
          </span>
        </div>
      </div>
    </footer>
  );
}
